import React, { Component } from 'react'
import { default as ReactDropzone } from 'react-dropzone'
import { Icon } from '@softwaredev_cegeka/stix-core'
import './fileReader.scss'

class FileReader extends Component {
    handleDrop = acceptedFiles => {
        let fileReader = new window.FileReader()
        fileReader.onload = event => {
            this.props.onRead(event)
        }
        // this has not been tested with multiple files, if you do please debug this
        acceptedFiles.forEach(file => {
            fileReader.readAsText(file)
        })
    }

    render() {
        return (
            <ReactDropzone
                onDrop={this.handleDrop}
                accept={this.props.allowedMimeType}
                maxFiles={this.props.maxFiles}
            >
                {({ getRootProps, getInputProps }) => (
                    <section className={'upload-container'}>
                        <div
                            {...getRootProps({
                                className: 'dropzone',
                            })}
                        >
                            <input {...getInputProps(this.props.name)} />
                            <p>
                                Drag 'n' drop an file, or click to select a file
                            </p>
                            <Icon icon={'reports'} />
                        </div>
                    </section>
                )}
            </ReactDropzone>
        )
    }
}

export default FileReader
